import { Box, Typography } from '@mui/material'
import { useEffect, useState } from 'react'

export default function VerticalBar({
  label,
  value,
  max = 1000,
  color = '#5B7DB1',
  width = 64,
  height = 120,
  delay = 0
}) {
  const targetPercent = Math.min((value / max) * 100, 100)
  const [percent, setPercent] = useState(0)

  useEffect(() => {
    const t = setTimeout(() => setPercent(targetPercent), delay)
    return () => clearTimeout(t)
  }, [targetPercent, delay])

  return (
    <Box sx={{ textAlign: 'center', width }}>
      <Box sx={{ position: 'relative', height, display: 'flex', alignItems: 'flex-end' }}>
        <Typography
          className="vertical-bar-value"
          sx={{
            position: 'absolute',
            bottom: `calc(${percent}% + 6px)`,
            width: '100%',
            textAlign: 'center',
            fontWeight: 700,
            color
          }}
        >
          {value}
        </Typography>

        <Box
          className="vertical-bar"
          sx={{
            width: '100%',
            height: `${percent}%`,
            backgroundColor: color
          }}
        />
      </Box>

      <Typography sx={{ mt: 1, fontWeight: 700, color }}>
        {label}
      </Typography>
    </Box>
  )
}
